// extracted by mini-css-extract-plugin
module.exports = {"addressBox":"styles_addressBox__9VjrK","changeAddress":"styles_changeAddress__so493"};